import RefCodePage from "./ref-code.page";

export default RefCodePage;
